import { render, staticRenderFns } from "./AccountHolderExpenseSubmission.vue?vue&type=template&id=f3775186&scoped=true"
import script from "./AccountHolderExpenseSubmission.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseSubmission.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenseSubmission.vue?vue&type=style&index=0&id=f3775186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3775186",
  null
  
)

export default component.exports